// src/components/matchInput/BestPlayerStep.js
import React, { useMemo } from "react";
import { getLeagueConfig } from "../../utils/leagueConfig";
import Dropdown from "../../central/Dropdown";

export default function BestPlayerStep({
  players = [],
  appearanceData = {},
  bestPlayers = {},
  setBestPlayers,
  leagueType,
}) {
  // Debugging
  console.log("👀 BestPlayerStep appearanceData:", appearanceData);

  const appearedPlayers = useMemo(() => {
    return players.filter((p) => appearanceData[p.id]?.appeared === true);
  }, [players, appearanceData]);

  console.log("👀 Eligible appeared players:", appearedPlayers);

  const handleChange = (rank, selectedValue) => {
    setBestPlayers((prev) => ({
      ...prev,
      [Number(rank)]: selectedValue || null,
    }));
  };

  const optionsForRank = (rank) => {
    const chosen = new Set(Object.values(bestPlayers).filter(Boolean));
    chosen.delete(bestPlayers[rank]);
    return appearedPlayers.filter((p) => !chosen.has(p.id));
  };

  const bonusSlots = getLeagueConfig(leagueType)?.bonusSlots || 3;

  const ranks = Array.from({ length: bonusSlots }, (_, i) => {
    const n = i + 1;
    let suffix = "th";
    if (n === 1) suffix = "st";
    else if (n === 2) suffix = "nd";
    else if (n === 3) suffix = "rd";
    return { key: n, label: `${n}${suffix} Place` };
  });

  const buildOptions = (rank) => [
    { label: "-- Select Player --", value: "" },
    ...optionsForRank(rank).map((p) => ({
      label: `${p.name} (${p.position})`,
      value: p.id,
    })),
  ];

  const getMatchedOption = (rank) => {
    const opts = buildOptions(rank);
    const selectedID = bestPlayers[rank] || "";
    return opts.find((o) => o.value === selectedID) || opts[0];
  };

  return (
    <div>
      <div
        style={{
          fontStyle: "italic",
          marginBottom: 8,
          fontSize: "0.9em",
        }}
      >
        Select the <strong>Top {bonusSlots} players</strong> for bonus
        <br/>
        Only players who appeared are eligible
      </div>
      {ranks.map(({ key, label }) => (
        <div
          key={key}
          style={{
            marginBottom: 6,
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <label style={{ width: "100px", textAlign: "left" }}>{label}:</label>
          <div style={{ flex: "1", maxWidth: "250px" }}>
            <Dropdown
              value={getMatchedOption(key)}
              onChange={(option) => {
                const raw = option && typeof option === "object" ? option.value : option;
                handleChange(key, raw || "");
              }}
              options={buildOptions(key)}
            />
          </div>
        </div>
      ))}
    </div>
  );
}